import { useEffect, useState } from 'react'

export function useLockoutRemaining(lockedUntilMs: number | null): number {
  const computeRemaining = (untilMs: number | null) =>
    untilMs
      ? Math.max(0, Math.ceil((untilMs - Date.now()) / 1000))
      : 0

  const [remaining, setRemaining] = useState(() =>
    computeRemaining(lockedUntilMs)
  )

  useEffect(() => {
    if (!lockedUntilMs) {
      setRemaining(0)
      return
    }
    const tick = () => {
      setRemaining(computeRemaining(lockedUntilMs))
    }
    tick()
    const id = globalThis.setInterval(tick, 1000)
    return () => globalThis.clearInterval(id)
  }, [lockedUntilMs])

  return remaining
}
